<template>
  <TextInput
    :label="label"
    :disabled="disabled"
    :size="size"
    :errorMessage="errorMessage"
  >
    <template #start>
      <span
        class="text-secondary front-medium"
        :class="{
          'text-style-sm': size == 'sm',
          'text-style-base': size == 'lg',
        }"
      >
        €
      </span>
    </template>
    <template #input>
      <input
        ref="input"
        type="text"
        v-model="value"
        :placeholder="placeholder"
        :name="label"
        :disabled="disabled"
        :class="
          cn(
            inputVariants({
              size,
              disabled,
              hasStartSlot: true,
              hasError: !!errorMessage,
            }),
            props.class
          )
        "
        @input="onInput"
        @blur="onBlur"
      />
    </template>
  </TextInput>
</template>

<script setup>
import { ref, watch } from "vue";
import { useCurrencyInput } from "vue-currency-input";
import { TextInput, inputVariants } from "@/SharedComponents/Inputs";
import { cn } from "@/Utils/cn";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: { type: String, required: false },
  label: { type: String, required: false },
  placeholder: { type: String, default: "0,00" },
  disabled: { type: Boolean, default: false },
  autoFocus: { type: Boolean, default: false },
  size: { type: String, required: false },
  errorMessage: { type: String, default: "" },
  class: { type: null, required: false },
});

const { input } = useCurrencyInput({
  locale: "nl-BE",
  currency: "EUR",
  currencyDisplay: "hidden",
});

const value = ref(props.modelValue);

function onInput(e) {
  // Replace periods with commas
  let cleanedValue = e.target.value.replace(/\./g, ",");

  // Remove any non-numeric characters except commas
  cleanedValue = cleanedValue.replace(/[^0-9,]/g, "");

  // Allow only one comma in the input
  const commaIndex = cleanedValue.indexOf(",");
  if (commaIndex !== -1) {
    cleanedValue =
      cleanedValue.slice(0, commaIndex + 1) +
      cleanedValue.slice(commaIndex + 1).replace(/,/g, "");
  }

  value.value = cleanedValue;
}

function onBlur(e) {
  const numericValue = parseFloat(e.target.value.replace(",", "."));

  if (!isNaN(numericValue)) {
    value.value = numericValue.toFixed(2).replace(".", ",");
  } else {
    value.value = "0,00";
  }
}

watch(value, () => {
  emit("update:modelValue", value.value);
});
</script>
